import db_lib from 'xAppLib/libs/db_lib';
import firebase_firestore from 'xAppLib/providers/firebase_firestore.js';

const _MODEL_NAME = 'game_players_model';

const DEBUG = false;

// ---- --------------------------------------------  --------------------------------------------
// ---- --------------------------------------------  --------------------------------------------

export default class game_players_model extends db_lib {

	static get MODEL_NAME() { return _MODEL_NAME; }

// ---- --------------------------------------------  --------------------------------------------
// ---- --------------------------------------------  --------------------------------------------

	static async create_marker(gid) {

		DEBUG && console.log('game_players_model.create_marker', gid)

		const collectionPath = `game_players/${app.user?.uid}/games`;

		firebase_firestore.set_record(
			collectionPath,
			gid,
			{ gid },
			{ timestamp: true }
		)

	}

// ---- --------------------------------------------  --------------------------------------------
// ---- --------------------------------------------  --------------------------------------------

}
